import React, { useCallback } from 'react';
import styles from './LanguageSwitch.module.scss';
import { useTranslation } from 'react-i18next';
import Select from '../../Common/Select/Select';
import { ReactComponent as LanguageIcon } from '../../../assets/icons/translation.svg';
import { supportedLanguages } from '../../../i18n/config';
import StorageService from '../../../services/storage.service';
import { setLanguageHeader } from '../../../common/http';
import useDefaultLanguage from "../../../utils/useDefaultLanguage";

function LanguageSwitch() {
  const { i18n } = useTranslation();

  const defaultLanguage = useDefaultLanguage();

  const onChangeLanguage = useCallback((value: string) => {
    StorageService.updateLanguage(value);
    i18n.changeLanguage(value);
    setLanguageHeader(value);
  }, []);

  return (
    <Select
      icon={<LanguageIcon className={styles.languageSwitchIcon} />}
      noMessages
      wrapperClassName={styles.languageSwitchWrapper}
      inputClassName={styles.languageSwitchInput}
      optionsWrapperClassName={styles.languageSwitchOptionsWrapper}
      defaultValue={defaultLanguage.label}
      options={supportedLanguages}
      onChangeAction={onChangeLanguage}
    />
  );
}

export default LanguageSwitch;
